import { Box, Table, TableContainer, Tbody, Td, Text, Th, Thead, Tr } from "@chakra-ui/react";
import type { SlideComoUtilizar } from "@/components/consignado/Cobranca/VinculosAtivosRedesign/ComoUtilizarModal";
import { fieldFont } from "./styleTokens";

/**
 * Slide "Formatos" do Como utilizar — o formato com que cada variável nasce e
 * para quais dá para trocar. Espelha formatoPadrao (catalogo.helpers) e os
 * exemplos que o catálogo publica em /catalogo/formatacoes; mudando a regra
 * lá, mudar aqui também.
 */
const LINHAS: { campo: string; padrao: string; exemplo: string; outros: string }[] = [
  { campo: "Valores em reais, IOF, margem", padrao: "Moeda (R$)", exemplo: "R$ 1.234,56", outros: "Decimal, Número, Texto" },
  { campo: "Taxas de juros e CET", padrao: "Decimal (pt-BR)", exemplo: "1,79", outros: "Moeda, Número, Texto" },
  { campo: "Quantidade de parcelas, posição", padrao: "Número", exemplo: "12", outros: "Decimal, Moeda, Texto" },
  { campo: "Datas (criação, desembolso…)", padrao: "Data (dd/mm/aaaa)", exemplo: "22/09/2026", outros: "Competência, Texto" },
  { campo: "Competência", padrao: "Competência (mm/aaaa)", exemplo: "09/2026", outros: "Data, Texto" },
  { campo: "CPF", padrao: "CPF mascarado", exemplo: "***.456.789-**", outros: "CPF completo (123.456.789-00), Texto" },
  { campo: "CNPJ", padrao: "CNPJ", exemplo: "12.345.678/0001-00", outros: "Texto" },
  { campo: "Nome, e-mail, telefone, número da CCB e demais textos", padrao: "Texto", exemplo: "Maria", outros: "—" },
];

function TabelaFormatos() {
  return (
    <Box {...fieldFont}>
      <Text fontSize="sm" color="gray.600" mb={3} {...fieldFont}>
        O formato é a máscara aplicada ao valor quando a mensagem é enviada — não muda de onde o
        valor vem. Cada variável nasce com o formato padrão do campo; para trocar, clique no formato
        na lista <strong>De onde vem cada variável</strong>, abaixo da mensagem. Só aparecem os
        formatos que servem para aquele campo.
      </Text>
      <TableContainer borderWidth="1px" borderColor="gray.200" borderRadius="md">
        <Table size="sm" variant="simple">
          <Thead bg="gray.50">
            <Tr>
              <Th fontSize="10px" {...fieldFont}>Campo</Th>
              <Th fontSize="10px" {...fieldFont}>Padrão</Th>
              <Th fontSize="10px" {...fieldFont}>Sai assim</Th>
              <Th fontSize="10px" {...fieldFont}>Dá para trocar por</Th>
            </Tr>
          </Thead>
          <Tbody>
            {LINHAS.map((l) => (
              <Tr key={l.campo}>
                <Td fontSize="xs" whiteSpace="normal" {...fieldFont}>{l.campo}</Td>
                <Td fontSize="xs" fontWeight="600" {...fieldFont}>{l.padrao}</Td>
                <Td fontSize="xs" fontFamily="monospace">{l.exemplo}</Td>
                <Td fontSize="xs" whiteSpace="normal" color="gray.600" {...fieldFont}>{l.outros}</Td>
              </Tr>
            ))}
          </Tbody>
        </Table>
      </TableContainer>
      <Text fontSize="xs" color="gray.500" mt={2} {...fieldFont}>
        Em Texto, o valor sai como está no cadastro, sem máscara — um valor em reais sai como
        1234.56 e o CPF sai completo.
      </Text>
    </Box>
  );
}

export const SLIDE_FORMATOS: SlideComoUtilizar = {
  titulo: "Formatos",
  conteudo: <TabelaFormatos />,
};
